class CopyToClipboard extends HTMLElement {
  private trigger: HTMLElement | null = null;
  private status: HTMLElement | null = null;
  private resetTimer: number | undefined;
  private static RESET_DELAY_MS = 1500;

  connectedCallback(): void {
    this.trigger = this.querySelector<HTMLElement>('[data-copy-trigger]') ?? this.querySelector<HTMLElement>('button');
    this.status = this.querySelector<HTMLElement>('[data-copy-status]');
    this.trigger?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback(): void {
    this.trigger?.removeEventListener('click', this.handleClick);
    if (this.resetTimer) window.clearTimeout(this.resetTimer);
  }

  private handleClick = async (): Promise<void> => {
    const text = this.dataset.copyText ?? this.trigger?.textContent?.trim() ?? '';
    if (!text || !navigator.clipboard) return;

    try {
      await navigator.clipboard.writeText(text);
    } catch {
      return;
    }

    this.toggleAttribute('data-copied', true);
    if (this.status && this.dataset.copiedLabel) {
      this.status.textContent = this.dataset.copiedLabel;
    }

    window.clearTimeout(this.resetTimer);
    this.resetTimer = window.setTimeout(() => {
      this.removeAttribute('data-copied');
      if (this.status) this.status.textContent = '';
    }, CopyToClipboard.RESET_DELAY_MS);
  };
}

if (!customElements.get('copy-to-clipboard')) {
  customElements.define('copy-to-clipboard', CopyToClipboard);
}
